/**
 * CDN 기본 URL
 */
const CDN_BASE_URL = 'https://cdn.welfarehello.com/static';

/**
 * CDN URL을 생성하는 유틸리티 함수
 * @param path - CDN 경로 (예: 'home-promotion-contents.png')
 * @returns 완전한 CDN URL
 */
export const getStaticCdnUrl = (path: string): string => {
  // path가 이미 전체 URL인 경우 그대로 반환
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }

  // path가 '/'로 시작하는 경우 제거
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;

  return `${CDN_BASE_URL}/${cleanPath}`;
};
